import React from 'react';
import Icon from '../../../components/AppIcon';

const PricingSection = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el?.scrollIntoView({ behavior: 'smooth' });
  };

  const includes = [
    'GRP Graphene batterij ([kWh varianten])',
    'Bidirectionele omvormer',
    'Energiemanagementsysteem (EMS)',
    'Professionele installatie (1 dag)',
    'Klantenportaal Verduurzaamwijzer.nu',
    '[GARANTIE X] jaar garantie',
  ];

  return (
    <section id="prijs" className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center space-x-2 text-primary bg-primary/10 px-3 py-1.5 rounded-full text-xs font-heading font-semibold uppercase tracking-wider mb-4">
            <Icon name="Tag" size={12} />
            <span>Transparante prijzen</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-foreground leading-tight mb-4">
            Geen verrassingen: één prijs voor het complete systeem
          </h2>
          <p className="font-body text-muted-foreground">
            Inclusief installatie en inbedrijfstelling. Altijd de totaalprijs — nooit alleen de batterijprijs.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10">
          <div className="rounded-2xl border border-primary shadow-elevation-2 ring-2 ring-primary/20 overflow-hidden">
            {/* Header */}
            <div className="px-6 py-5 bg-primary/5">
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-heading font-bold text-foreground">GRP Graphene</h3>
                <span className="text-xs font-heading font-semibold px-2.5 py-1 rounded-full bg-primary text-primary-foreground">
                  Meest gekozen
                </span>
              </div>
              <p className="text-3xl font-heading font-black text-foreground">[PRIJS]</p>
              <p className="text-xs font-caption text-muted-foreground mt-0.5">compleet geïnstalleerd, incl. btw</p>
            </div>

            {/* Value stack */}
            <div className="px-6 py-5 space-y-2.5">
              {includes?.map((item, i) => (
                <div key={i} className="flex items-start space-x-2.5">
                  <div className="w-5 h-5 rounded-full bg-primary/15 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Icon name="Check" size={11} className="text-primary" />
                  </div>
                  <span className="text-sm font-body text-foreground">{item}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="px-6 pb-6">
              <button
                onClick={() => scrollTo('formulier')}
                className="w-full py-3 font-heading font-semibold text-sm rounded-md transition-colors bg-primary text-primary-foreground hover:bg-primary/90"
              >
                Vraag offerte aan
              </button>
            </div>
          </div>
        </div>

        {/* Notes */}
        <div className="max-w-md mx-auto space-y-3">
          <div className="flex items-start space-x-3 bg-gray-50 border border-border rounded-xl p-4">
            <Icon name="Info" size={16} className="text-muted-foreground flex-shrink-0 mt-0.5" />
            <p className="text-sm font-body text-muted-foreground">
              <strong className="text-foreground">Financiering:</strong> Mogelijkheden voor financiering of lease via partner worden besproken in het adviesgesprek. [Beslispunt te bevestigen]
            </p>
          </div>
          <div className="flex items-start space-x-3 bg-gray-50 border border-border rounded-xl p-4">
            <Icon name="Info" size={16} className="text-muted-foreground flex-shrink-0 mt-0.5" />
            <p className="text-sm font-body text-muted-foreground">
              <strong className="text-foreground">BTW & subsidies:</strong> Fiscale voordelen en actuele subsidiemogelijkheden worden besproken in het adviesgesprek. [Fiscale check vereist vóór publicatie]
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
